// @flow
import React from 'react';
import classnames from 'classnames';
import { isEmpty } from 'lodash';

import { NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT } from 'Components/widgets/navigation/Navigation.constants';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

export type NavItem = {
  color: Colors,
  image?: {
    imageUrl: string,
    ratioKey?: MediaRatios,
    mandatoryWidthAndHeight?: {
      w: number,
      h: number,
    },
  },
  thumbnail?: {
    imageUrl: string,
  },
  isList?: boolean,
  label: string,
  link: {
    trackingData?: TrackingData,
    url: string,
  },
  seeMoreLabel?: string,
  subItems?: Array<NavItem>,
};

type Props = {
  parentLabel?: string,
  subItems: Array<NavItem>,
};

export function NavigationLargeSubNavList(props: Props) {
  const { subItems = [] } = props;

  if (isEmpty(subItems)) {
    return null;
  }

  return (
    <div
      className="bg-white overflow-y-auto py-6 px-12"
      style={{ maxHeight: NAVIGATIONLARGE_SUBNAV_MAX_HEIGHT }}
    >
      <ul className="reset-list colum-count-5 column-gap-50">
        {subItems.map((item, index) => (
          <li
            className={`break-inside-avoid-column ${index ? 'my-4' : ''}`}
            data-testid="NavigationLargeSubNavList-sublist-item"
            key={item.label}
          >
            <TrackClick
              {...item.link}
              as={DynamicLink}
              className={classnames(
                `text-${item.color}`,
                {
                  [`focus:text-${item.color}-active hover:text-${item.color}-active`]: !!item.color,
                },
                'reset-anchor font-bold font-sans text-md focus:text-blue hover:text-blue',
              )}
              data-testid="NavigationLargeSubNavList-sublist-link"
            >
              {item.label}
            </TrackClick>
            {!isEmpty(item.subItems) && (
              <ul className="reset-list mt-4">
                {(item.subItems || []).map(subItem => (
                  <li key={subItem.label}>
                    <TrackClick
                      {...subItem.link}
                      as={DynamicLink}
                      className="reset-anchor font-bold font-sans text-gray-darker text-sm focus:text-blue hover:text-blue"
                      data-testid="NavigationLargeSubNavList-subsublist-link"
                    >
                      {subItem.label}
                    </TrackClick>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
